import { initializeApp } from 'firebase/app';
import {
  getMessaging,
  isSupported,
  getToken,
  onMessage,
} from 'firebase/messaging';
import Store from './Store/Store';
import { BaseInfoActions } from './Reducer/BaseInfoReducer';

const firebaseConfig = {
  apiKey: 'AIzaSyAAaLVk9HOYuCUmBmS3icXiSFFRv-ALsPc',
  authDomain: 'safeon-56eeb.firebaseapp.com',
  projectId: 'safeon-56eeb',
  storageBucket: 'safeon-56eeb.firebasestorage.app',
  messagingSenderId: '546743957112',
  appId: '1:546743957112:web:94528cd50379a238bcdf8d',
};
const app = initializeApp(firebaseConfig);
let firebaseToken = '';
let fcmReceptionPayload = null;

export async function initFcm() {
  // ✅ 웹 (PWA)
  if (!(await isSupported()))
    return { supported: false, granted: false, token: '' };
  const swReg = await navigator.serviceWorker.register(
    '/firebase-messaging-sw.js'
  );
  const messaging = getMessaging(app);

  onMessage(messaging, (payload) => {
    console.log('[Web FCM] Foreground message:', payload);

    fcmReceptionPayload = payload;
    Store.dispatch(BaseInfoActions.setFcmReceptionPayload(payload));
  });

  const perm = await Notification.requestPermission();
  if (perm !== 'granted')
    return { supported: true, granted: false, token: '' };

  const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY;
  const token = await getToken(messaging, {
    vapidKey,
    serviceWorkerRegistration: swReg,
  });

  return { supported: true, granted: true, token };
}

export function getReceptionPayload() {
  return fcmReceptionPayload;
}
